import lazyPage from '../../hoc/lazyPage'

export default () => ({
  path: '/',
  component: lazyPage(() => import('../../containers/Home')),
  exact: true,
})
